<template>
	<view>
		<stepLine :active="2" :steps="steps"/>
		<view class="main-container">
			<view class="tips">审核未通过</view>
			<view class="tips-detail">抱歉，您的审核未通过，可以重新申请</view>
			<view class="next-btn" @click="reApply">重新申请</view>
		</view>
	</view>
</template>

<script>
	import stepLine from '@/components/common/stepLine.vue'
	import { mapState } from 'vuex'
	export default {
		components: {
			stepLine
		},
		data() {
			return {
				steps: [
					{ title: '基本信息' },
					{ title: '资质认证' },
					{ title: '提交审核' }
				],
			}
		},
		computed: {
			...mapState(['statusbarHeight', 'navHeight'])
		},
		methods: {
			reApply() {
				uni.redirectTo({
					url: '/pages/merchant/applyMerchant/merchantMessage'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
.main-container {
	text-align: center;
	margin-top: 158rpx;
	font-family: PingFang SC-Medium, PingFang SC;
	.tips {
		height: 40rpx;
		font-size: 40rpx;
		font-weight: 400;
		color: #333333;
		line-height: 40rpx;
	}
	.tips-detail {
		height: 24rpx;
		font-size: 24rpx;
		font-weight: 400;
		color: #999999;
		line-height: 24rpx;
		margin-top: 28rpx;
	}
	.next-btn {
		height: 72rpx;
		margin: 88rpx 56rpx 0;
		background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
		border-radius: 36rpx 36rpx 36rpx 36rpx;
		color: #FFFFFF;
		line-height: 72rpx;
		text-align: center;
	}
}
</style>
